import { render, staticRenderFns } from "./InviteToTeamModal.vue?vue&type=template&id=701a491b&scoped=true&"
import script from "./InviteToTeamModal.vue?vue&type=script&lang=js&"
export * from "./InviteToTeamModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701a491b",
  null
  
)

export default component.exports